import { computed, defineComponent, inject, onMounted } from 'vue';

import { Routes } from "@/enums/routes";
import { PortalType } from "@/enums/portal-types";
import { IStore } from "@/interfaces/state.interface";

export default defineComponent({
	setup: () => {
		const store = inject('store') as IStore;
		const portal = computed((): PortalType | null => {
			return store.getters.portal();
		});
		const isLoggedIn = computed((): boolean => {
			return store.getters.isLoggedIn();
		});

		const redirectToResult = (): void => {
			store.mutations.setCurrentRoute(Routes.RESULTS);
		};

		const triggerAuthenticationService = (): void => {
			document.dispatchEvent(new CustomEvent('RenderAuthenticationService', {
				detail: {
					referrer: 'PersonalityTest',
					tabToShow: 'third_party_login'
				}
			}));
		};

		const waitForAuthCompleted = (): void => {
			document.addEventListener(
				'authentication_completed',
				redirectToResult.bind(this)
			);
		};

		const redirectWhenLoggedIn = (): void => {
			if (isLoggedIn.value) {
				redirectToResult();
				return;
			}

			triggerAuthenticationService();
			waitForAuthCompleted();
		};

		onMounted(redirectWhenLoggedIn);

		return { portal };
	}
});
